import { useLingui } from '@lingui/react/macro';

import {
  FilterCheckboxItem,
  FilterItemNoResults,
  FiltersList,
  FiltersSubMenu,
} from '@/design_system/Filters/FiltersDrawer/FiltersDrawer';
import IconStep from '@/icons/Step.svg';

import { useFilters } from '../FiltersState';
import { useStepOptions } from '../utils';

export const FiltersStep = () => {
  const { t, i18n } = useLingui();

  const {
    displayedSteps: { displayedSteps, setDisplayedSteps },
  } = useFilters();

  const stepOptions = useStepOptions();

  const toggleDisplayedStep = (step: (typeof displayedSteps)[number]) => {
    if (displayedSteps.includes(step)) {
      setDisplayedSteps(displayedSteps.filter((s) => s !== step));
    } else {
      setDisplayedSteps([...displayedSteps, step]);
    }
  };

  const options =
    stepOptions.length > 0 ? (
      stepOptions.map(({ id, name }) => (
        <FilterCheckboxItem key={id} id={id} label={i18n._(name)} />
      ))
    ) : (
      <FilterItemNoResults />
    );

  return (
    <FiltersSubMenu
      id="step"
      icon={<IconStep />}
      label={t({ id: 'requests.filters.step.label', message: 'Step' })}
      count={displayedSteps.length}
    >
      <FiltersList
        ariaLabel={t({ id: 'requests.filters.step.label', message: 'Step' })}
        values={displayedSteps}
        onChange={toggleDisplayedStep}
      >
        {options}
      </FiltersList>
    </FiltersSubMenu>
  );
};
